import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const quickSortNotificationVideoUrl =
  'https://app.arcade.software/share/videos/J5J3KKQ9LIcP6Ekd7mF7';

type QuickSortNotificationDialogProps = {
  open: boolean;
  onClose: () => void;
  onCreateExampleGame: () => Promise<void>;
  isCreatingExampleGame: boolean;
  createExampleGameError: string | null;
};

export const QuickSortNotificationDialog = ({
  open,
  onClose,
  onCreateExampleGame,
  isCreatingExampleGame,
  createExampleGameError,
}: QuickSortNotificationDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
    <DialogTitle>Introducing Quick Sorts</DialogTitle>
    <DialogContent dividers sx={{ height: { xs: 360, md: 640 } }}>
      {createExampleGameError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {createExampleGameError}
        </Alert>
      ) : null}
      <iframe
        src={quickSortNotificationVideoUrl}
        title="Introducing Quick Sorts"
        frameBorder="0"
        loading="lazy"
        allowFullScreen
        allow="clipboard-write"
        style={{
          width: '100%',
          height: '100%',
          colorScheme: 'light',
        }}
      />
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button onClick={() => void onCreateExampleGame()} disabled={isCreatingExampleGame}>
        {isCreatingExampleGame ? 'Creating...' : 'Create an example Quick Sort Game'}
      </Button>
      <Button onClick={onClose} disabled={isCreatingExampleGame} variant="contained">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
